import { useEffect } from 'react';

import scrollToTop from 'functions/scrollToTop';

export function useScrollToTop() {
	useEffect(() => {
		scrollToTop();
	}, []);
}
